import { useEffect, useRef, useState } from 'react';

const HEADER_HEIGHT = 200;

// Хук для использования IntersectionObserver в отслеживании скролла и блоков
export function useIntersectionObserver() {
  const [activeSection, setActiveSection] = useState<string>('');
  const observerRef = useRef<IntersectionObserver | null>(null);
  const sectionsRef = useRef<Map<string, HTMLElement>>(new Map());

  useEffect(() => {
    if (observerRef.current) return;

    const handleIntersect: IntersectionObserverCallback = (entries) => {
      const visibleEntries = entries.filter((entry) => entry.isIntersecting);
      if (visibleEntries.length > 0) {
        const activeHash = visibleEntries[0].target.querySelector(
          '[class*=InvisibleAnchor]',
        )?.id;
        if (activeHash) setActiveSection(activeHash);
      }
    };

    observerRef.current = new IntersectionObserver(handleIntersect, {
      root: null,
      rootMargin: `-${HEADER_HEIGHT}px 0px 0px 0px`,
      threshold: [0, 0.25, 0.5, 0.75, 1],
    });

    return () => observerRef.current?.disconnect();
  }, []);

  const registerSection = (id: string, elem: HTMLElement) => {
    sectionsRef.current?.set(id, elem);
    observerRef.current?.observe(elem);
  };
  const unregisterSection = (id: string) => {
    const element = sectionsRef.current.get(id);
    if (element) observerRef.current?.unobserve(element);
    sectionsRef.current.delete(id);
  };

  const scrollToSection = (id: string) => {
    const elem = sectionsRef.current?.get(id);
    if (!elem) return;

    setActiveSection(id);

    const topPos = elem.offsetTop - HEADER_HEIGHT;
    window.scrollTo({ top: topPos, behavior: 'smooth' });
  };

  return { activeSection, registerSection, unregisterSection, scrollToSection };
}
